import { createContext } from 'react';

export const ProjectSummaryContext = createContext({});